import { api } from './client'

export interface GrowerPayment {
    id: string
    grower_id: string
    amount: number
    transferred_at: string
    bill_file_id?: string | null
    created_by: string
    created_at: string
    updated_at: string
    // Hydrate từ server (join), chỉ đọc.
    grower_name?: string
    grower_phone?: string
    bank_number?: string
    bank_name?: string
    bank_account?: string
    bill_image_url?: string
    creator_name?: string
}

export interface UpsertGrowerPaymentRequest {
    grower_id: string
    amount: number
    /** ISO-8601, ví dụ 2026-08-24T09:30:00Z */
    transferred_at: string
    bill_file_id?: string | null
}

export interface ListGrowerPaymentsParams {
    grower_id?: string
    from_date?: string
    to_date?: string
    page?: number
    per_page?: number
    /** Chỉ endpoint summary dùng: thêm `periods` theo kỳ giờ Việt Nam. */
    group_by?: 'week' | 'month' | 'year'
}

/** Tổng tiền đã chuyển trong một kỳ (ngày đầu kỳ theo lịch Việt Nam). */
export interface GrowerPaymentPeriod {
    period_start: string
    total_amount: number
    count: number
}

export interface GrowerPaymentSummary {
    total_amount: number
    count: number
    /** Chỉ có khi gọi kèm `group_by`; kỳ không có phiếu thì vắng mặt. */
    periods?: GrowerPaymentPeriod[]
}

export const growerPaymentApi = {
    list: (params?: ListGrowerPaymentsParams) =>
        api.get<GrowerPayment[]>('/grower-payments', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    // Tổng tiền là của TOÀN BỘ bộ lọc nên phải hỏi riêng — envelope phân trang
    // chỉ mang page/per_page/total/total_pages.
    summary: (params?: ListGrowerPaymentsParams) =>
        api.get<GrowerPaymentSummary>('/grower-payments/summary', {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    getById: (id: string) => api.get<GrowerPayment>(`/grower-payments/${id}`),
    create: (data: UpsertGrowerPaymentRequest) =>
        api.post<GrowerPayment>('/grower-payments', data),
    update: (id: string, data: UpsertGrowerPaymentRequest) =>
        api.put<GrowerPayment>(`/grower-payments/${id}`, data),
    delete: (id: string) => api.delete(`/grower-payments/${id}`),
}
